"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unmountRevieve = exports.showRevieve = exports.setTryOnProduct = exports.isAnalyticsConsentGranted = exports.initRevieve = exports.hideRevieve = exports.getRevieveUserId = void 0;
var _constants = require("../constants");
var _cookies = require("./cookies");
/* istanbul ignore file @preserve -- window script calls */

const getRevieveUserId = () => (0, _cookies.getCookie)(_constants.REVIEVE_USER_ID_COOKIE);
exports.getRevieveUserId = getRevieveUserId;
const hideRevieve = () => window.Revieve?.API.hide();
exports.hideRevieve = hideRevieve;
const initRevieve = (config, callback) =>
// eslint-disable-next-line new-cap -- 3rd party naming
window.Revieve?.Init(config, callback);
exports.initRevieve = initRevieve;
const isAnalyticsConsentGranted = () => {
  if (!(0, _cookies.getCookie)(_constants.OPTANON_CONSENT_COOKIE)) {
    return true;
  }
  return new RegExp(`groups=[^;]*${_constants.ONE_TRUST_GROUP_PERFORMANCE}%3A1`).test((0, _cookies.getCookie)(_constants.OPTANON_CONSENT_COOKIE) ?? '');
};
exports.isAnalyticsConsentGranted = isAnalyticsConsentGranted;
const showRevieve = () => window.Revieve?.API.show();
exports.showRevieve = showRevieve;
const unmountRevieve = () => window.Revieve?.API.unmount();
exports.unmountRevieve = unmountRevieve;
const setTryOnProduct = productCode => {
  if (productCode) {
    window.Revieve?.API.liveAR.addTryOnProduct(productCode);
  }
};
exports.setTryOnProduct = setTryOnProduct;